// extracted by mini-css-extract-plugin
module.exports = {"footer":"ChangeUsernameModal_footer__2S85D","label":"ChangeUsernameModal_label__1TmOi","error":"ChangeUsernameModal_error__CDGba"};